var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-1 p-3 shadow bg-neutral-100",class:{
        'cursor-pointer': _vm.clickable,
        'text-primary-700': _vm.active,
        'text-neutral-500': !_vm.active,
    },on:{"click":_vm.tabClicked}},[_c('div',[_vm._t("tab",null,{"tabIndex":_vm.index,"tabTitle":_vm.tab.title,"tabDescription":_vm.tab.description})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }